import { TripCard } from "@/app/Cities/Trips/Components/TripCard";
import { useTripRecord } from "@/app/Cities/Trips/Hooks/useTripRecord";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";

export function TripDetailScreen() {
  const trip = useTripRecord();

  return (
    <RecordScreenCard>
      <TripCard cityAId={trip.cityA.id} cityBId={trip.cityB.id} />
    </RecordScreenCard>
  );
}
